module.exports = __webpack_public_path__ + "img/map-bigEN.09825184.png";